import { useAppDispatch } from '@/state/hooks';

import { roundedFullClassname } from '@/helpers/environmentHelper';
import { setXplorTraderMobileLayoutNode } from '@/state/reducers/xplorTraderLayoutSlice';
import useLanguage from '@/utils/hooks/useLanguage';
import useScreenSizes from '@/utils/hooks/useScreenSizes';
import useXplorTraderLayout, { XplorTraderModules, xplorTraderTabIcon } from '@/utils/hooks/useXplorTraderLayout';
import cn from 'classnames';
import { useMemo } from 'react';
import { IconType } from 'react-icons/lib';
import { MdPriceChange } from 'react-icons/md';
import { updateTree } from 'react-mosaic-component';

const TabletTabNavigation = () => {
    const dispatch = useAppDispatch();

    const lang = useLanguage();
    const screen = useScreenSizes();
    const { layout } = useXplorTraderLayout(screen);

    const tabs: {
        label: string;
        name: XplorTraderModules;
        title: string;
        Icon: IconType;
    }[] = useMemo(() => {
        return [
            {
                label: 'Tickers',
                name: 'Tickers',
                title: lang.locale !== 'en' ? lang.modules.tickers : 'Tickers',
                Icon: xplorTraderTabIcon['Tickers']
            },
            {
                label: 'Prices',
                name: 'Order Book',
                title: lang.locale !== 'en' ? lang.modules['order-book'] : 'Market Depth',
                Icon: MdPriceChange
            },
            {
                label: 'Chart',
                name: 'Chart',
                title: lang.locale !== 'en' ? lang.modules.chart : 'Chart',
                Icon: xplorTraderTabIcon['Chart']
            },
            {
                label: 'Blotters',
                name: 'Blotter',
                title: lang.locale !== 'en' ? lang.modules.blotter : 'Blotter',
                Icon: xplorTraderTabIcon['Blotter']
            },
            {
                label: 'Account Value',
                name: 'Account Value',
                title: lang.locale !== 'en' ? lang.modules['account-value'] : 'Account Value',
                Icon: xplorTraderTabIcon['Account Value']
            }
        ];
    }, [lang]);

    return (
        <div className="flex items-center justify-between w-full">
            <div className="flex gap-0.5">
                {tabs.map(({ name, title, Icon }) => (
                    <div
                        key={name}
                        className={cn(
                            'flex uppercase cursor-pointer text-brand-text font-semibold px-2 gap-2 items-center',
                            {
                                ['bg-brand-accent text-brand-module-title']: name === layout?.second,
                                ['bg-brand-neutral-800 hover:bg-brand-neutral-700']: name !== layout?.second
                            },
                            roundedFullClassname
                        )}
                        onClick={() => switchTab(layout, name, dispatch)}>
                        <Icon className="w-3.5 h-3.5" />
                        {title}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TabletTabNavigation;

const switchTab = (mobileLayoutNode, moduleToDrop, dispatch) => {
    let currentNode = mobileLayoutNode;
    if (currentNode) {
        currentNode = updateTree(currentNode, [
            {
                path: [],
                spec: {
                    $set: {
                        direction: 'row',
                        first: '',
                        second: moduleToDrop,
                        splitPercentage: 0
                    }
                }
            }
        ]);
    } else {
        currentNode = moduleToDrop;
    }
    dispatch(setXplorTraderMobileLayoutNode(currentNode));
};
